import React from "react";
import TimeCard from "./TimeCard";
import "./Summary.css";

// https://leancrew.com/all-this/2020/06/ordinal-numerals-and-javascript/
function ordinal(n) {
  var s = ["th", "st", "nd", "rd"];
  var v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

const Summary = (props) => {
  let n, rawData, ao5Data, ma5Data, ma12Data, ma20Data;

  if(props.solving){
    return <React.Fragment>SOLVE {props.puzzle}</React.Fragment>
  }  

  if (props.data && props.data.length > 0) {
    n = props.data.length;
    rawData = props.data.map((elx) => {
      let x = parseFloat(elx.item) ;
      return x;
    });

    //console.log(props.data)

    ao5Data = props.data.map((elx) => parseFloat(elx.ao5));
    ma5Data = props.data.map((elx) => parseFloat(elx.ma5));
    ma12Data = props.data.map((elx) => parseFloat(elx.ma12));
    ma20Data = props.data.map((elx) => parseFloat(elx.ma20));
    
  } else {

    return <div>Accurate timing, statistics, data visualization</div>;
  }

  //rawData = rawData.filter(x => x > 0);
  // const rawSorted = [...rawData].sort((a, b) => a - b);
  // const rank = rawSorted.indexOf(rawData[0]) + 1;

  let rawFiltered = rawData.filter((x)=>x > 0);
  const rawSorted = [...rawFiltered].sort((a, b) => a - b);
  const rank = rawSorted.indexOf(rawData[0]) + 1;

  let ordn = ordinal(rank);

  let lastValue = rawData[0];
  if(lastValue === -2){
    lastValue = "DNF";
    ordn = "";
  }else{

    lastValue = <TimeCard tmSeconds={lastValue}></TimeCard>
    //lastValue = <TimeCard tmSeconds='43'></TimeCard>
  }

  let lastAo5 = <TimeCard tmSeconds={ao5Data[0]}></TimeCard>
  let lastMo5 = <TimeCard tmSeconds={ma5Data[0]}></TimeCard>
  let lastMo12 = <TimeCard tmSeconds={ma12Data[0]}></TimeCard>
  let lastMo20 = <TimeCard tmSeconds={ma20Data[0]}></TimeCard>

  

  return <React.Fragment>

      {/* <div className="summary-puzzle">{props.puzzle}</div> */}
      {/* <div className="summary-count">{lastValue} </div> */}
      <div className="summary-rank">{ordn} of {n}</div>
      <div className="summary-time">A<sub>5</sub> {lastAo5}</div>
      <div className="summary-time">M<sub>5</sub> {lastMo5}</div>
      <div className="summary-time">M<sub>12</sub> {lastMo12}</div>
      <div className="summary-time">M<sub>20</sub> {lastMo20}</div>

  </React.Fragment>;
};

export default Summary;
